import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { SentPitch } from '../outreachTypes';
import { useRetry } from './useRetry';

/** `outreach.campaigns.sentPitch` (design outreach-v2 g3): the text of one sent pitch, for the drawer. */
export function useSentPitch(accountId: number, campaignUuid: string, messageUuid: string | null) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.campaigns.sentPitch.queryOptions(
      { accountId, campaignUuid, messageUuid: messageUuid ?? '' },
      { enabled: messageUuid !== null, retry: false }
    )
  );
  const retry = useRetry(query.refetch);
  return {
    pitch: (query.data ?? undefined) as SentPitch | undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
